<div [class.loading-blur]="loading()" [class.loading-blur--done]="!loading()">
  <div class="top_details">
    @if (locationDetails) {
      <ng-container [ngTemplateOutlet]="locationDetailsPart" [ngTemplateOutletContext]="{ details: locationDetails }"></ng-container>
      <ng-container [ngTemplateOutlet]="defaultValuesPart" [ngTemplateOutletContext]="{ details: locationDetails }"></ng-container>
      @if (priceRegulationsFeatureEnabled() && priceRegulations().length > 0) {
        <ng-container [ngTemplateOutlet]="priceRegulationsPart"></ng-container>
      }
    }
  </div>
  <ng-container [ngTemplateOutlet]="connectorsListPart"></ng-container>
</div>
<ng-template #locationDetailsPart let-details="details">
  <div>
    <h3>Lokationsdetaljer</h3>
    <table class="table">
      <tbody>
        <tr valign="top">
          <td>
            <strong>Kategori:</strong>
          </td>
          <td class="align-right">
            {{ details.category | translateLocationCategoryEnum | emptyDash }}
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>Produkt:</strong>
          </td>
          <td class="align-right">
            {{ details.product | translateLocationProduct | emptyDash }}
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>App ikon:</strong>
          </td>
          <td class="align-right">
            {{ details.appVisibilityStatus | translateLocationStatusEnum | emptyDash }}
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>Konceptanlægsnummer:</strong>
          </td>
          <td class="align-right">
            {{ details.conceptInstallationNumber | emptyDash }}
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>OK-måler:</strong>
          </td>
          <td class="align-right">
            @if (details.hasOkPowerMeter === null || details.hasOkPowerMeter === undefined) {
              -
            } @else {
              {{ details.hasOkPowerMeter ? 'Ja' : 'Nej' }}
            }
          </td>
        </tr>
        @if (powerPriceExclusionFeatureEnabled() && details.hasOkPowerMeter === false) {
          <tr valign="top">
            <td>
              <strong>Ekskludér strømsats i beregning (firmabiler):</strong>
            </td>
            <td class="align-right">
              {{ details.hasPowerPriceExclusion ? 'Ja' : 'Nej' }}
            </td>
          </tr>
        }
        <tr valign="top">
          <td>
            <strong>kWh godtgørelsesaftalenummer:</strong>
          </td>
          <td class="align-right">
            {{ details.kwhCompensationAgreementNumber | emptyDash }}
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>Målepunkts-ID'er:</strong>
          </td>
          <td class="align-right">
            @if (details.meteringPointIdentifiers?.length) {
              @for (identifier of details.meteringPointIdentifiers; track identifier) {
                <div>{{ identifier.slice(0, 7) }}-{{ identifier.slice(7) }}</div>
              }
            } @else {
              -
            }
          </td>
        </tr>

        <tr valign="top">
          <td>
            <strong>Kickback politik:</strong>
          </td>
          <td class="align-right">
            @if (details.kickBack) {
              <a
                class="blue"
                [routerLink]="['/organizations']"
                [queryParams]="{
                  organizationId: location().organizationId,
                  kickbackId: details.kickBack.id,
                }">
                {{ details.kickBack.name }}
              </a>
            } @else {
              -
            }
          </td>
        </tr>

        <tr valign="top">
          <td>
            <strong>Tilgængelige faciliteter:</strong>
          </td>
          <td class="align-right">
            {{ details.facilities | translateLocationFacility | emptyDash }}
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>Understøtter store køretøjer:</strong>
          </td>
          <td class="align-right">
            {{ details.isLargeVehicleAccessible ? 'Ja' : 'Nej' }}
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>OBS tekst:</strong>
          </td>
          <td class="align-right">
            {{ details.appLocationText | emptyDash }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #defaultValuesPart let-details="details">
  <div class="col">
    <h3 class="flex">Standardværdier for ladepunkter</h3>
    <table class="table">
      <tbody>
        <tr valign="top">
          <td>
            <strong>Prispolitik:</strong>
          </td>
          <td class="align-right">
            @if (details.defaultPricePolicy) {
              <a class="blue" [routerLink]="['/price-policies']" [queryParams]="{ pricePolicyId: details.defaultPricePolicy.id }">
                {{ details.defaultPricePolicy.name }}
              </a>
            } @else {
              -
            }
          </td>
        </tr>
        <tr valign="top">
          <td>
            <strong>Adgangsgrupper:</strong>
          </td>
          <td class="align-right default-access-groups">
            @for (accessGroup of details.defaultAccessGroups; track accessGroup; let last = $last) {
              <a
                class="blue"
                [routerLink]="['/access-groups']"
                [queryParams]="{
                  accessGroupIdentifier: accessGroup.identifier,
                  filterName: accessGroup.name,
                }"
                >{{ accessGroup.name }}</a
              >
              <!-- NOTE: Intentional formatting to avoid spaces before commas. Do not auto-format this block. -->
              <!-- prettier-ignore -->
              @if (!last) {,
            }
            }
          </td>
        </tr>
      </tbody>
    </table>
    @if (accessGroups.length > 0) {
      <div>
        <h3 class="flex">Tilknyttede adgangsgrupper</h3>
        <table class="table table--center-vert">
          <thead>
            <tr>
              <th class="align-left">Navn</th>
              <th class="align-left">Rabat pr. kWh</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (accessGroup of accessGroups; track accessGroup) {
              <tr valign="top">
                <td>
                  {{ accessGroup.name }}
                </td>
                <td>
                  @if (accessGroup.discountType === discountType.FixedAmount) {
                    {{ accessGroup.amount | dkCurrency }}
                  }
                  @if (accessGroup.discountType === discountType.Percentages) {
                    {{ accessGroup.amount | number: '1.2-2' }} %
                  }
                </td>
                <td>
                  <div class="flex">
                    <a
                      [routerLink]="['/access-groups']"
                      [queryParams]="{ accessGroupIdentifier: accessGroup.identifier, filterName: accessGroup.name }"
                      target="_new"
                      class="blue icon-with-text margin--left-auto no-wrap"
                      title="Se detaljer">
                      <mat-icon class="material-icons">find_in_page</mat-icon>
                      <span>Se detaljer</span>
                    </a>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</ng-template>

<ng-template #priceRegulationsPart>
  <div>
    <h3 class="flex">Prisreguleringer for adgangsgrupper</h3>
    <table class="table table--center-vert">
      <thead>
        <tr>
          <th class="align-left">Prisregulering</th>
          <th class="align-left">Adgangsgruppe(r)</th>
        </tr>
      </thead>
      <tbody>
        @for (regulation of priceRegulations(); track regulation.identifier) {
          <tr valign="top">
            <td>
              <a
                class="blue"
                [routerLink]="['/price-regulations']"
                [queryParams]="{ priceRegulationIdentifier: regulation.identifier, query: regulation.name }">
                {{ regulation.name }}
              </a>
              @if (regulation.type === PriceRegulationType.Discount && regulation.discountAmountInKrWithoutVat !== null) {
                <div>Rabat (kr./kWh) {{ regulation.discountAmountInKrWithoutVat | dkCurrency }} ekskl. moms</div>
              } @else if (regulation.type === PriceRegulationType.SupplementOverride) {
                @if (
                  regulation.okSupplementOverrideInKrWithoutVat !== null && regulation.okSupplementOverrideInKrWithoutVat !== undefined
                ) {
                  <div>OK-tillæg: {{ regulation.okSupplementOverrideInKrWithoutVat | dkCurrency }} ekskl. moms</div>
                }
                @if (
                  regulation.organizationSupplementOverrideInKrWithoutVat !== null &&
                  regulation.organizationSupplementOverrideInKrWithoutVat !== undefined
                ) {
                  <div>Kundetillæg: {{ regulation.organizationSupplementOverrideInKrWithoutVat | dkCurrency }} ekskl. moms</div>
                }
              }
            </td>
            <td class="default-access-groups">
              @for (accessGroup of regulation.accessGroups; track accessGroup.identifier; let last = $last) {
                <a
                  class="blue"
                  [routerLink]="['/access-groups']"
                  [queryParams]="{ accessGroupIdentifier: accessGroup.identifier, filterName: accessGroup.name }"
                  >{{ accessGroup.name }}</a
                >
                <!-- prettier-ignore -->
                @if (!last) {,
            }
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #connectorsListPart>
  <div class="header">
    <h3>Ladepunkter på lokation</h3>
    @if (chargingStations().length > 0) {
      <div
        class="header__button"
        [admRequiresFeatureRole]="
          roles['charging-station-location-price-policy.write'] + ',' + roles['charging-station-location-access-group.write']
        ">
        <span>Rediger alle ladepunkter for lokation</span>
        <div class="buttons">
          <button
            mat-stroked-button
            class="margin--left-auto"
            type="button"
            (click)="updateConnectorPrices()"
            [admRequiresFeatureRole]="roles['charging-station-location-price-policy.write']">
            <mat-icon svgIcon="sell_outlined"></mat-icon>
            Prispolitik
          </button>
          <button
            mat-stroked-button
            class="margin--left-m"
            type="button"
            (click)="updateAccessGroupForAllLocations()"
            [admRequiresFeatureRole]="roles['charging-station-location-access-group.write']">
            <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg>
            Adgangsgrupper
          </button>
        </div>
      </div>
    }
  </div>
  <div class="list" [class.hasConnectors]="chargingStations().length > 0">
    @if (chargingStations().length === 0) {
      <span class="italic">Der er ingen ladepunkter på denne lokation</span>
    } @else {
      <adm-connector-list
        [connectors]="connectors()"
        [location]="location()"
        [organizationId]="location().organizationId"
        [selectedPricePolicyId]="selectedPricePolicyId()"
        (reloadRequested)="refreshAfterUpdate()" />
    }
  </div>
</ng-template>
